<template>
  <div class="questions" v-if="app!=null && app.data !=null" >

    <div class="launcher" id="questions-content">
      <div v-for="quizz in app.data[app.currentMusee].collections[0].quizz.filter(x => x.id == app.currentQuizz)" :key="quizz">
        <div @click="app.displaySettings()" id="boule" class="new-boule"><svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30"  style="fill: rgb(128, 151, 13);"><path d="M130.001-254.616V-300h699.998v45.384H130.001Zm0-202.692v-45.384h699.998v45.384H130.001Zm0-202.692v-45.384h699.998V-660H130.001Z"/></svg></div>
        <div class="quizz-title">
          <h1 id="display-junior" style="display: none">Junior</h1>
          <h1 id="display-decouverte" style="display: none">Decouverte</h1>
          <h1 id="display-expert" style="display: none">Expert</h1>
          <img id="space" src="white-line.png" style="width: 3px; display: none">
          <img id="space-exp" src="white-line.png" style="width: 3px; display: none">
          <h1> / </h1>
          <h1 id="quizz-title"></h1> 
        </div>
      </div>

      <div v-for="questions in app.data[app.currentMusee].collections[0].quizz[app.currentQuizz].questions.filter(x => x.id == app.currentQuestion)" :key="questions">

        <p id="question-number">{{questions.id +1}}</p>
        <img id="top-img" :src="questions.media" />
        <p id="indice" @click="app.getIndice">Indice</p>
        <div id="progressbar" style="font-size: 8pt">{{questions.id+1}}/{{app.totalQuestions + 1}}
          <div id="progressbar-content" :style="{'width': app.progressbarWidth}"></div>
        </div>

        <div id="hidden">
          <span @click="app.removeIndice"><img src="arrows/cross.png"></span>
          <h1>Indice</h1>
          <p>{{questions.indice}}</p>
        </div>

        <div id="answer">

          <div id="good-answer">
            <button id="next-question" @click="app.changeQuestion(questions.id)"><img src="arrows/arrow.png"></button><br>
            <h2>Bonne réponse</h2>
            <div class="solution"><p style="text-align : justify; line-height: 130%;">{{questions.more}}</p></div>
          </div>

          <div id="wrong-answer">
            <button id="next-question" @click="app.changeQuestion(questions.id)"><img src="arrows/arrow.png"></button><br>
            <h2 style="font-weight : 700">Mauvaise réponse</h2>
            <p style="text-align: center; margin-bottom: -10px">La bonne réponse était: </p>
            <h3 >{{questions.answers[app.good]}}</h3>
            <div class="solution"><p style="text-align : justify; line-height: 130%;">{{questions.more}}</p></div>

          </div>

        </div>

        

        <div id="question-selector">
          <img class="line" id="line" src="line.png">
          <p>{{questions.desc}}</p>
          
          <button id="answer0" @click="app.setAnswer0()"><strong>{{questions.answers[0]}}</strong></button>
          <button id="answer1" @click="app.setAnswer1()"><strong>{{questions.answers[1]}}</strong></button>
          <button id="answer2" @click="app.setAnswer2()"><strong>{{questions.answers[2]}}</strong></button>
          <button id="answer3" @click="app.setAnswer3()"><strong>{{questions.answers[3]}}</strong></button>
        </div>
      </div>
    </div>
    
    <score
      v-bind:app="app"
    ></score>
    
    <settings
      v-bind:app="app"
    ></settings>


  </div>
</template>

<script>
import score from './score.vue';
import settings from './settings.vue';

export default {
  name: 'QuestionsVue',
  props: {
    app:Object
  },
  components :{
    score,
    settings
  }
}
</script>


